export default __webpack_public_path__ + "static/media/lg-logo.e1a6e127.svg";